<template>
  <div @mouseenter="handleEnter" @mouseleave="handleLeave" class="ff-lang">
    <!-- <span
      :class="{ open: isOpen }"
      @click="handleClick"
      @touchstart="handleTouch"
      class="selected-lang"
    >
      {{ selectedLang.abbr }}
    </span> -->
    <span
      @click="handleClick"
      @touchstart="handleTouch"
      class="global-lang"
    >
    </span>
    <transition name="slide-bottom">
      <ul class="lang-list" ref="langList" v-show="$bus.langListOpen">
        <li
          :class="{ active: langIndex === index }"
          :key="index"
          @click.stop="selectLang(index)"
          class="lang-item"
          v-for="(lang, index) in langList"
        >
          {{ lang.name }}
        </li>
      </ul>
    </transition>
  </div>
</template>
<script>
  import { mapState } from '@/utils/assist'
  export default {
    name: 'toggle-lang',
    data() {
      return {
        // isOpen: false,
        hasTouch: false,
      }
    },
    computed: {
      ...mapState(['is_ind','langs', 'indiaLangs', 'langIndex', 'selectedLang']),
      langList() {
        return this.is_ind ? this.indiaLangs : this.langs
      },
      // isOpen() {
      //   return this.$bus.langListOpen
      // }
    },
    // watch: {
    //   // isOpen watch
    //   isOpen(val) {
    //     this.$bus.langListOpen = val
    //   }
    // },
    methods: {
      selectLang(index) {
        this.$bus.langIndex = index
        this.$bus.langListOpen = false
        this.$bus.addGA('selectLang', this.selectedLang.abbr)
      },
      // 只有移动端触发 touch 事件
      handleTouch() {
        this.hasTouch = true
        // this.isOpen = !this.isOpen
        this.$bus.langListOpen = !this.$bus.langListOpen
      },
      handleEnter() {
        if (!this.hasTouch) {
          // this.isOpen = true
          this.$bus.langListOpen = true
        }
      },
      handleLeave() {
        // this.isOpen = false
        this.$bus.langListOpen = false
      },
      handleClick() {
        if (!this.hasTouch) {
          // this.isOpen = !this.isOpen
          this.$bus.langListOpen = !this.$bus.langListOpen
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/toggle-lang/toggle-lang.vue